import React, { useState, useContext, useEffect } from 'react';
import { LanguageContext } from '../LanguageContext';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { language, setLanguage } = useContext(LanguageContext);
  const logo = require('../img/Doyouf Arahman Travels أﺳﻔـﺎـر ﺿﻴـﻮـف اﻟﺮﺣﻤـﻦـ.png');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const content = {
    fr: {
      home: 'Accueil',
      omra: 'Omra',
      hajj: 'Hajj',
      blog: 'Blog',
      contact: 'Contact',
    },
    ar: {
      home: 'الرئيسية',
      omra: 'عمرة',
      hajj: 'حج',
      blog: 'مدونة',
      contact: 'اتصل بنا',
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/70 backdrop-blur-md shadow-sm' : 'bg-white'
      }`}
    >
      <nav className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          
          <div className="flex items-center">
            <img
              src={logo}
              alt="Logo"
              className="h-24 w-auto" // ✅ Logo agrandi
            />
          </div>

         
          <div className="hidden md:flex space-x-10 items-center">
            {['home', 'omra', 'hajj', 'blog', 'contact'].map((key) => (
              <a
                key={key}
                href={`/${key === 'home' ? '' : key}`}
                className="text-gray-800 hover:text-green-600 transition-colors duration-300 font-bold text-sm uppercase"
              >
                {content[language][key]}
              </a>
            ))}
            
            <div className="flex items-center space-x-2 ml-4 bg-gray-100 rounded-full p-1">
              {['fr', 'ar'].map((lang) => (
                <button
                  key={lang}
                  onClick={() => setLanguage(lang)}
                  className={`px-3 py-1 rounded-full transition-colors duration-300 ${
                    language === lang ? 'bg-white text-green-600' : 'text-gray-600 hover:bg-white'
                  }`}
                >
                  {lang.toUpperCase()}
                </button>
              ))}
            </div>
          </div>

        
          <div className="md:hidden flex items-center">
            <div className="flex items-center space-x-2 mr-4 bg-gray-100 rounded-full p-1">
              {['fr', 'ar'].map((lang) => (
                <button
                  key={lang}
                  onClick={() => setLanguage(lang)}
                  className={`px-3 py-1 rounded-full transition-colors duration-300 ${
                    language === lang ? 'bg-white text-green-600' : 'text-gray-600 hover:bg-white'
                  }`}
                >
                  {lang.toUpperCase()}
                </button>
              ))}
            </div>
            <button onClick={toggleMenu} className="text-gray-800 focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

   
        <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} mt-2 bg-white rounded-lg p-4 shadow-md`}>
          {['home', 'omra', 'hajj', 'blog', 'contact'].map((key) => (
            <a
              key={key}
              href={`/${key === 'home' ? '' : key}`}
              className="block text-gray-800 hover:text-green-600 py-2 font-bold text-sm"
            >
              {content[language][key]}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
